var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.161 50.3425C248.286 57.574 275.048 100.956 293.913 121.743L313.576 113.328C319.026 70.1482 304.344 48.3345 292.161 50.3425Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.429 86.6097C200.515 126.042 257.415 130.046 283.298 135.049L293.34 117.655C273.128 82.1312 238.865 73.7407 229.429 86.6097Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M368.414 66.0195C348.109 88.326 307.929 124.703 292.486 136.8C283.907 143.52 265.718 168.458 261.6 214.443L242.296 340.561C238.435 380.884 253.021 419.234 278.759 461.101C295.203 484.409 336.155 511.977 368.414 435.792C376.85 414.487 393.809 363.725 373.561 322.544C363.695 296.377 360.177 243.099 380.425 237.608C403.875 226.884 453.264 198.571 463.216 171.117",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333.767 377.881C332.773 393.094 338.739 425.031 370.558 431.074",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M293.425 415.62C300 433.991 320.236 469.931 348.58 466.721",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.472 317.239C222.262 190.496 273.994 132.543 311.214 107.85C315.041 105.312 320.023 108.192 320.609 112.746C327.744 168.225 390.144 197.891 422.048 211.349C426.695 213.309 426.961 219.784 422.618 222.346C360.354 259.09 367.115 287.309 378.328 312.052C380.442 316.716 376.218 321.876 371.176 320.982C328.82 313.467 264.946 319.008 238.43 322.817C234.946 323.317 231.727 320.75 231.472 317.239Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.029 166.828C279.474 190.707 336.842 234.348 426.754 217.875",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400.587 228.6C383.142 252.479 325.774 296.12 235.862 279.647",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M313.075 109.774C309.501 136.371 309.987 194.711 340.53 215.301",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M344.317 497.947L333.623 475L320.048 486.675L344.317 497.947Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M379.599 464.147L363.036 445L353.171 459.943L379.599 464.147Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M392.599 430.147L376.036 411L366.171 425.943L392.599 430.147Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.249 176.372L130.068 110L143.552 163.351L127.068 168.5L188.431 238.547L171.876 181.121L188.249 176.372Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.859 259.501L65.9996 273.741L113.825 288.197L110.123 303.432L193.33 288.434L140.898 274.464L144.859 259.501Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/정형외과_관절염.07072c810aaa8f8b00087e807085f689.svg";
export { ForwardRef as ReactComponent };